// extracted by mini-css-extract-plugin
export default {"container":"DY-z","title":"EY-z","link":"FY-z"};